// extracted by mini-css-extract-plugin
module.exports = {"snapshotWrapper":"MovieDetailsSnapshotsView_snapshotWrapper__rZc4m","hovered":"MovieDetailsSnapshotsView_hovered__UnfX6"};